import { render, staticRenderFns } from "./partners-list.vue?vue&type=template&id=55e6c34f&scoped=true&"
import script from "./partners-list.vue?vue&type=script&lang=js&"
export * from "./partners-list.vue?vue&type=script&lang=js&"
import style0 from "./partners-list.vue?vue&type=style&index=0&id=55e6c34f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6c34f",
  null
  
)

export default component.exports